import './styles/main.css';

import { initHexGrid }        from './modules/hex-grid.js';
import { initScrollReveal }   from './modules/scroll-reveal.js';
import { initCommandPalette } from './modules/command-palette.js';
import { initNavScroll }      from './modules/nav-scroll.js';
import { initCursorGlow }     from './modules/cursor-glow.js';
import { initContactForm }    from './modules/contact-form.js';
import { initMegaPreview }    from './modules/mega-preview.js';
import { initHeroCarousel }   from './modules/hero-carousel.js';

/**
 * App bootstrap. Each init* call is independent — failure in one
 * module never blocks the others. New behaviors should be added here
 * and implemented in their own file under src/modules/.
 *
 * NOTE: the DNA helix (and its heavy Three.js dependency, ~470 KB) is NOT
 * imported statically — it's lazy-loaded below only on pages that actually
 * render the canvas, so stub pages never pay for Three.js.
 */
function bootstrap() {
  const features = [
    initNavScroll,
    initScrollReveal,
    initHexGrid,
    initCommandPalette,
    initCursorGlow,
    initContactForm,
    initMegaPreview,
    initHeroCarousel,
  ];

  for (const init of features) {
    try {
      init();
    } catch (err) {
      console.error(`[bootstrap] ${init.name} failed`, err);
    }
  }

  // Lazy-load the DNA helix + Three.js only when the hero canvas is present.
  if (document.getElementById('bio-canvas')) {
    import('./modules/dna-helix.js')
      .then(({ initDnaHelix }) => initDnaHelix())
      .catch((err) => console.error('[bootstrap] dna-helix failed', err));
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
  bootstrap();
}
